module.exports = __webpack_public_path__ + "img/ads5.9fe60b2.webp";